export const NOTIFICATION_CATEGORY = {
  MARKET_HOURS_UPDATES: 'marketHoursUpdates',
  NEW_FEATURES_IN_THE_HUB: 'newFeaturesInTheHub',
  NEW_PAYMENT_OPTIONS: 'newPaymentOptions',
  PROMOTIONS: 'promotions',
  TRADE_IDEAS: 'tradeIdeas',
  COMPANY_NEWS: 'companyNews',
  OPERATIONAL_UPDATES: 'operationalUpdates',
};
